import { categories } from '../../../mocks/reports';

export default function CategoriesSection() {
  return (
    <section id="categories" className="bg-[#e9eae4] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-antonio text-5xl font-bold text-[#272727] mb-4 uppercase">
            Explore Categories
          </h2>
          <p className="text-lg text-[#272727]/60 font-barlow">
            Beyond clothing—more categories coming soon
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {categories.map((category, index) => (
            <a
              key={index}
              href="https://theboloreport.substack.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-[#272727] hover:bg-[#4d4d31] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${category.icon} text-4xl text-[#e9eae4]`}></i>
              </div>
              <h3 className="font-antonio text-2xl font-bold text-[#e9eae4] mb-3 uppercase">
                {category.name}
              </h3>
              <p className="text-base text-[#e9eae4]/65 leading-relaxed font-barlow">
                {category.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
